import { useQuery } from '@tanstack/react-query';
import { verificationService } from '../services/verification.service';
import type { ListVerificationsParams, Verification } from '../types/verification.types';

interface UseVerificationsReturn {
  verifications: Verification[];
  hasData: boolean;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
  refetch: () => void;
}

export function useVerifications(params: ListVerificationsParams): UseVerificationsReturn {
  const query = useQuery({
    queryKey: ['verifications', params],
    queryFn: () => verificationService.listVerifications(params),
    enabled: !!params.candidateId && !!params.experienceId,
  });

  return {
    verifications: query.data ?? [],
    hasData: query.data !== undefined,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
